import { useCore } from '@/composables/core'

import { useLogger } from '@booksy-com/vue-tools'

const logger = useLogger('router.guard.is-business-correct')

export default function (route, from, next) {
  logger.debug(route.path)

  // business route
  const br = route.matched.find(r => r.name === 'business')

  // shortcut: works only for business (sub-)routes
  if (!br) {
    return next()
  }

  const { store } = useCore()
  if (parseInt(route.params.businessId) !== parseInt(store.state.business.business.id)) {
    return next({
      name: route.name,
      params: {
        ...route.params,
        businessId: store.state.business.business.id,
      },
      query: route.query,
    })
  }

  next()
}
